import React from 'react'

export default function NoMatch() {
  return (
    <div>
        <h2 className='text-lg'>404 not found</h2>
    </div>
  )
}
